import React, { useEffect } from 'react';

const Logout = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
      <div className="modal fade show d-block bg-dark bg-opacity-50" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow-lg">
            <div className="modal-body text-center py-5">
              <p className="mb-3 fs-4 text-secondary">
                Are you sure you want to log out?
              </p>
              <i className="bi bi-box-arrow-right text-danger display-3"></i>
            </div>
            <div className="modal-footer border-0 d-flex justify-content-center pb-4 gap-3">
              <button type="button" className="btn btn-primary fw-bold px-4 py-2" onClick={onConfirm}>
                <i className="bi bi-box-arrow-right me-2"></i> Yes, Logout
              </button>
              <button type="button" className="btn btn-secondary fw-bold px-4 py-2" onClick={onCancel}>
                <i className="bi bi-x-circle me-2"></i> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Logout;